import React from 'react'
import {State} from 'country-state-city'
import useStyles from './style'
import { Box, Grid, Paper, Typography, IconButton } from '@material-ui/core'
import Select from 'react-select'
import {connect} from 'react-redux'
import viewAllMentors from '../../../assets/images/host-cohort.png'
import dropdownicon from '../../../assets/images/arrow.png'

const GlobalSelectComponent = (props) => {
    const classes = useStyles()

    const states = State.getStatesOfCountry("IN").map((item) => ({
        value: item.name,
        label: item.name,
      }));
    
      const removeFirstItem = (arr) => arr.filter((item, index) => index !== 0);

    return (
        <Paper elevation={3} className={classes.upperDisplay}>
          <Typography
            className={classes.secondHeading}
            style={{ fontSize: "28px" }}
          >
            {props.title}
          </Typography>
          <Box className={classes.filterContainer2}>
            <Grid container spacing={1} alignItems="center">
              
              <Grid item xs={8} md={2} className={classes.selectContainer}>
                <Select
                  className={classes.select}
                  options={removeFirstItem(
                    props.selectOptions.industry_options
                  )}
                  placeholder="Industry"
                />
              </Grid>
              <Grid item xs={12} md={2} className={classes.selectContainer}>
                <Select
                  className={classes.select}
                  placeholder="Industry Keyword"
                  options={removeFirstItem(props.selectOptions.sub_industry)}
                />
              </Grid>
              <Grid item xs={12} md={2} className={classes.selectContainer}>
                <Select
                  className={classes.select}
                  placeholder="Function"
                  options={removeFirstItem(props.selectOptions._specialisation)}
                />
              </Grid>
              <Grid item xs={12} md={2} className={classes.selectContainer}>
                <Select
                  className={classes.select}
                  placeholder="Function Keyword"
                  options={removeFirstItem(
                    props.selectOptions.functional_areas
                  )}
                />
              </Grid>
              <Grid item xs={12} md={2} className={classes.selectContainer}>
                <Select
                  className={classes.select}
                  placeholder="Stage"
                  options={props.selectOptions.stage_of_startup_options}
                />
              </Grid>
              <Grid item xs={12} md={2} className={classes.selectContainer}>
                <Select
                  className={classes.select}
                  placeholder="State"
                  options={states}
                />
              </Grid>
            </Grid>
            <IconButton style={{ height: "70px", width: "70px" }}>
              <img
                src={dropdownicon}
                className={classes.rightRotated}
                alt="drop down iconnn"
              />
            </IconButton>
          </Box>
        </Paper>
    )
}

const mapStateToProps = (state) => ({
    selectOptions: state.AdminMentorListReducer.getPredefineOptionsList.list,
  });
  
  export default connect(mapStateToProps, null)(GlobalSelectComponent);